import { render, staticRenderFns } from "./CampaignsGridViewCard.vue?vue&type=template&id=d197d2aa&scoped=true"
import script from "./CampaignsGridViewCard.vue?vue&type=script&lang=js"
export * from "./CampaignsGridViewCard.vue?vue&type=script&lang=js"
import style0 from "./CampaignsGridViewCard.vue?vue&type=style&index=0&id=d197d2aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d197d2aa",
  null
  
)

export default component.exports